module.exports = __webpack_public_path__ + "static/media/wx.png";